import { useState, useEffect, useCallback, createContext, useContext } from 'react';
import { useCouponAndModalForms } from '../../../couponAndModalFormsContext'
import { useModalForms } from '../../../../modalForms/modalFormsContext'
import { useSelector } from 'react-redux'

export const CouponRulesContext = createContext();


export function CouponRulesProvider({ children }){
    const { 
        changeVisibleContent, 
        setChangeVisibleContent,
        setFormChangeVisibleContentFromNavigatorButtons,
    } = useModalForms()


    const {  
        couponDatasToCreateOrEdit, 
        setCouponDatasToCreateOrEdit 
    } = useCouponAndModalForms()

    
    const modalForms = useSelector(state =>  state.modalForms)
   
    const [cardCouponRuleSelected, setCardCouponRuleSelected] = useState(0)

    const [productsSelectedsToLink, setProductsSelectedsToLink] = useState([])
 
    const [inputMinValueChecked, setInputMinValueChecked] = useState(false) 
    const [inputMaxQuantityChecked, setInputMaxQuantityChecked] = useState(false) 
    const [inputMinValueText, setInputMinValueText] = useState(0)
    const [inputMaxQuantityText, setInputMaxQuantityText] = useState(0)

    const [couponActive, setCouponActive] = useState(false)
    const [couponForOnlinePayment, setCouponForOnlinePayment] = useState(false)
    const [secretCoupon, setSecretCoupon] = useState(false)


    const handleSetCouponInformations = useCallback(() => {
        setCouponDatasToCreateOrEdit({ 
            ...couponDatasToCreateOrEdit, 
            rule: cardCouponRuleSelected,
            active: couponActive,
            onlyOnlinePay: couponForOnlinePayment,
            minValue: inputMinValueText,
            unlimited: !inputMaxQuantityChecked,
            availableQuantity: inputMaxQuantityText,
            secret: secretCoupon,
            productsSelectedsToLink
        })
    }, [
        couponDatasToCreateOrEdit, 
        setCouponDatasToCreateOrEdit,
        couponActive,
        cardCouponRuleSelected,
        inputMinValueText,
        inputMaxQuantityChecked,
        inputMaxQuantityText,
        couponForOnlinePayment,
        secretCoupon, 
        productsSelectedsToLink
    ])


    const handleClearCouponInformations = useCallback(() => {
        setCouponDatasToCreateOrEdit({ 
            ...couponDatasToCreateOrEdit, 
            rule: '',
            active: '',
            onlyOnlinePay: '',
            minValue: '',
            unlimited: '',
            availableQuantity: '',
            secret: '',
            productsSelectedsToLink: []
        })
    }, [couponDatasToCreateOrEdit, setCouponDatasToCreateOrEdit])


    function handleConfirmCouponRules() {
        if(cardCouponRuleSelected !== ''){
            setChangeVisibleContent(2)
            setFormChangeVisibleContentFromNavigatorButtons(2)
            handleSetCouponInformations()
        }     
    }


    useEffect(() =>{
        if(modalForms.typeModal === 0){
           setCardCouponRuleSelected(couponDatasToCreateOrEdit.rule)
           setCouponActive(couponDatasToCreateOrEdit.active)
           setCouponForOnlinePayment(couponDatasToCreateOrEdit.onlyOnlinePay)
           setSecretCoupon(couponDatasToCreateOrEdit.secret)
           setProductsSelectedsToLink(couponDatasToCreateOrEdit.productsSelectedsToLink)

           if(!couponDatasToCreateOrEdit.unlimited){
                setInputMaxQuantityChecked(true)
                setInputMaxQuantityText(couponDatasToCreateOrEdit.availableQuantity)
           }
              
            if(couponDatasToCreateOrEdit.minValue > 0){
                setInputMinValueChecked(true)
                setInputMinValueText(couponDatasToCreateOrEdit.minValue)
            }   
        }
    }, [couponDatasToCreateOrEdit, modalForms])


    useEffect(() =>{
        if(cardCouponRuleSelected === ''){
            setFormChangeVisibleContentFromNavigatorButtons(-1)
            handleClearCouponInformations()
        }
    },[ 
        setFormChangeVisibleContentFromNavigatorButtons, 
        cardCouponRuleSelected,
        handleClearCouponInformations
    ])

    useEffect(() => {
        if(inputMinValueChecked === false)
            setInputMinValueText(0)
        if(inputMaxQuantityChecked === false)
            setInputMaxQuantityText(0)
    }, [inputMinValueChecked, inputMaxQuantityChecked])

    useEffect(() => {
        if(changeVisibleContent === 1){
            setFormChangeVisibleContentFromNavigatorButtons(1)
        }
    }, [setFormChangeVisibleContentFromNavigatorButtons, changeVisibleContent])


    useEffect(() => {
        if(modalForms.isOpen === false){
            setCardCouponRuleSelected(0)
            setInputMinValueChecked(false)
            setInputMaxQuantityChecked(false)
            setInputMinValueText(0)
            setInputMaxQuantityText(0)
            setSecretCoupon(false)
            setProductsSelectedsToLink([])
        }
    }, [modalForms])



    return(
        <CouponRulesContext.Provider 
            value={ { 
              cardCouponRuleSelected, setCardCouponRuleSelected,
              inputMinValueChecked, setInputMinValueChecked,
              inputMinValueText, setInputMinValueText,
              inputMaxQuantityChecked, setInputMaxQuantityChecked,
              inputMaxQuantityText, setInputMaxQuantityText,
              couponActive, setCouponActive, 
              couponForOnlinePayment, setCouponForOnlinePayment,
              secretCoupon, setSecretCoupon,
              productsSelectedsToLink, setProductsSelectedsToLink,
              handleConfirmCouponRules 
            }}
        >
            { children }
        </CouponRulesContext.Provider>
    )
    }



export function useCouponRules() {
   const context = useContext(CouponRulesContext)

   if(!context) {
    throw new Error('useCouponRules must be used within an Provider');
  } 

   return context
}
